var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isThemeLoaded && _vm.theme == 'Operator-Template')?_c('EmbeddedLayout',{style:(_vm.merchantStyle)}):(_vm.isThemeLoaded && _vm.theme != 'Operator-Template')?_c('StandAloneLayout',{style:(_vm.merchantStyle)}):_c('v-app',[_c('v-container',[_c('MainLoader')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }